import React from "react";
import styles from "./topLeftMapControl.module.scss";

const TopLeftMapControl = (props) => {
  const { left = "60px", top = "5px" } = props;

  const style = { left: left, top: top, width: `calc(100% - ${left})`};

  return (
    <div className={styles.map_control_container_left} style={style}>
      <div className={styles.containerItems}>{props.children}</div>
    </div>
  );
};

export default React.memo(TopLeftMapControl);
